export default __webpack_public_path__ + "static/media/communityImage.53c9762f.svg";